<template>
  <div :class="returnLoadingClasses">
    <div v-if="type !== 'placeholder'">
      <SbIcon
        v-if="type === 'spinner'"
        aria-busy="true"
        :size="size"
        name="loading"
        :color="color"
        :aria-hidden="ariaHidden"
      />
    </div>
    <slot v-else />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import SbIcon from '../../Icon'
import type { SbLoadingProps } from '../types'

// eslint-disable-next-line vue/prop-name-casing
const props = defineProps<SbLoadingProps>()

const isSpinner = computed(() => props.type === 'spinner')

const returnSizeOfSpinner = computed(() => {
  if (isSpinner.value) {
    return `sb-loading__spinner--${props.size || 'large'}`
  }
  return ''
})

const returnLoadingClasses = computed(() => [
  'sb-loading',
  props.uiBlock && 'sb-loading__block',
  isSpinner.value && 'sb-loading__spinner',
  returnSizeOfSpinner.value,
])
</script>
